import { OperatorType, TermCode } from '@bechtel/sr-types';

export const getFilterByTermCodeLevel = (termCodesLevel) => {
  const filter = {
    field: 'value',
    operator: OperatorType.LIKE,
    value: '',
  };
  switch (termCodesLevel) {
    case TermCode.C:
      filter.value = 'C';
      break;
    case TermCode.JC:
      filter.value = 'J';
      break;
    case TermCode.PRJC:
      filter.value = 'P';
      break;
    case TermCode.RJC:
      filter.value = 'R';
      break;
    default:
      return {};
  }
  return {
    and: [filter],
  };
};
